import React, { useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import _ from 'lodash';
import NumberFormat from "react-number-format";
import { useToasts } from "react-toast-notifications";
import { COLOR_APP, COLOR_APP_CANCEL } from "../../../constants";
import { CREATE_ORDER_FROM_COMMENT_V2 } from "../../../graphql/order/mutation";
import { useMutation } from "@apollo/client";
function CreateOrderModal({ updateLiveStock, updateOrder, fetchLiveStocks, getLiveOrders, fetchLiveOrders, liveId, showCreateOrderModal, setShowCreateOrderModal, selectedComment, liveStocks }) {
    const [selectedStock, setSelectedStock] = useState({});
    const [amount, setAmount] = useState(0);

    const { addToast } = useToasts();

    const [createOrder, { loading: createLoading }] = useMutation(CREATE_ORDER_FROM_COMMENT_V2);

    const onSelectStock = async (e) => {
        const checkStock = liveStocks.filter(stock => e?.target?.value.trim().split("ລະຫັດ: ")[0] != "" ? stock.cfMessage == e?.target?.value.trim().split("ລະຫັດ: ")[0] : stock.cfMessage == e?.target?.value.trim().split("ລະຫັດ: ")[1])

        if (checkStock.length > 0) {
            setSelectedStock(checkStock[0]);
            setAmount(1)
        }
    }

    const _createOrder = async () => {
        try {
            if (createLoading) return;
            if (_.isEmpty(selectedStock)) return addToast("ເລືອກສິນຄ້າໃດຫນຶ່ງກ່ອນ!", {
                appearance: 'warning',
                autoDismiss: true,
            });
            if (amount <= 0) return addToast("ຈໍານວນສິນຄ້າຕ້ອງຫລາຍກວ່າ 1", {
                appearance: 'warning',
                autoDismiss: true,
            });
            const SHOP_ID = await localStorage.getItem("SHOP");

            let _newOrder = {
                type: "LIVE",
                live: liveId,
                liveStock: selectedStock?.id,
                stock: selectedStock?.stock?.id,
                price: selectedStock?.stock?.price,
                amount: parseInt(amount) ?? 1,
                productName: selectedStock?.stock?.name ?? "",
                currency: selectedStock?.stock?.currency ?? "ກີບ",
                cfMessage: selectedStock?.cfMessage ?? "",
                fbMessage: selectedComment?.message,
                commentId: selectedComment?.id,
                originPrice: parseInt(selectedStock?.stock?.originPrice) ?? 0,
                totalPrice: parseInt(selectedStock?.stock?.price * amount) ?? 0,
                cfName: selectedComment?.from?.name,
                shop: SHOP_ID,
                userFbId: selectedComment?.from?.id,
                isReply: true
            }
            let isDuplicate = false;
            let _res = await createOrder({
                variables: {
                    data: _newOrder,
                },
                // check order already exist
                // update: (cache, { data: { createOrderFromCommentV2 } }) => {
                //     if (createOrderFromCommentV2?.msg === "ຂໍ້ມູນມີແລ້ວ") {
                //         isDuplicate = true;
                //         return addToast("ສິນຄ້ານີ້ຖືກສ້າງໃນອໍເດີແລ້ວ!", {
                //             appearance: 'warning',
                //             autoDismiss: true,
                //         })
                //     }
                // }
            });
            if (isDuplicate) {
                setShowCreateOrderModal(false);
                _clearData();
                return;
            }

            const resp = _res?.data?.createOrderFromCommentV2;
            if (!resp?.status || _.isEmpty(resp?.data?.id)) {
                setShowCreateOrderModal(false);
                _clearData();
                return addToast(resp?.msg || "ສ້າງອໍເດີ້ບໍ່ສໍາເລັດ!" , {
                    appearance: 'error',
                    autoDismiss: true,
                })
            }
             

            _newOrder = { ..._newOrder, id: resp?.data?.id, isReply: resp?.data?.isReply, unsendMessage: resp?.data?.unsendMessage };
            updateOrder(_newOrder);
            updateLiveStock(selectedStock?.id, parseInt(amount) ?? 1);

            setShowCreateOrderModal(false);
            _clearData();
            addToast("ສ້າງອໍເດີ້ສໍາເລັດ!", {
                appearance: 'success',
                autoDismiss: true,
            })
            return
        } catch (error) {
            console.log("_createOrder Error: ", error);
            setShowCreateOrderModal(false);
            _clearData();
            addToast("ເກີດຂໍ້ຜິດພາດທີ່ບໍ່ຄາດຄິດ",{
                appearance:"error",
                autoDismiss:true
            })
        }
        return;
    }

    const _clearData = () => {
        setAmount(0)
        setSelectedStock()
    }

    return (
        <Modal show={showCreateOrderModal} onHide={() => {
            if (createLoading) return;
            setShowCreateOrderModal(false)
        }}>
            <Modal.Body>
                <h3 style={{ fontWeight: 'bold', alignSelf: 'center' }}>ສ້າງອໍເດີ້</h3>
                <Form.Group>
                    <div>ຊື່ລູກຄ້າ</div>
                    <Form.Control value={selectedComment?.from?.name} />
                </Form.Group>
                <div style={{ display: 'flex', margin: '10px 4px' }}>
                    <Form.Group style={{ marginRight: 20 }}>
                        <div style={{ textAlign: "start" }}>ລະຫັດ CF</div>
                        <div className="input-group">
                            <input
                                type="text"
                                list="listItem"
                                placeholder="ເລືອກສິນຄ້າ"
                                onChange={(e) => onSelectStock(e)}
                                className="form-control form-control-md"
                            />
                            <datalist id="listItem">
                                {liveStocks?.length > 0 && liveStocks?.map((lStock, index) => {
                                    if (lStock?.amount <= 0 || !lStock?.isPublished) return "";
                                    return (
                                        <option key={index} value={"ລະຫັດ: " + lStock?.cfMessage}>
                                            {"ສິນຄ້າ: " + lStock?.stock?.name}, {"ຈຳນວນ: " + lStock?.amount},{"ລາຄາ: " + lStock?.stock?.price}
                                        </option>
                                    );
                                })}
                            </datalist>
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <div>ຊື່ສິນຄ້າ</div>
                        <Form.Control readOnly placeholder="ຊື່ສິນຄ້າ..." value={selectedStock?.stock?.name ?? ''} />
                    </Form.Group>
                </div>
                <div style={{ display: 'flex', margin: '10px 4px' }}>
                    <Form.Group style={{ marginRight: 20 }}>
                        <div>ຈໍານວນ ({selectedStock?.amount})</div>
                        <NumberFormat
                            name="amount"
                            className="form-control"
                            onChange={(e) => {
                                if (e.target.value > selectedStock?.amount) {
                                    addToast("ປ້ອນຈໍານວນທີ່ນ້ອຍກວ່າ: " + selectedStock?.amount, {
                                        appearance: "error",
                                        autoDismiss: true,
                                    });
                                    return;
                                }
                                setAmount(e.target.value)
                            }
                            }
                            value={amount ?? 1}
                            placeholder="ຈໍານວນ"
                            thousandSeparator={true}
                            prefix={""}
                        />
                    </Form.Group>
                    <Form.Group>
                        <div>ລາຄາ</div>
                        <Form.Control readOnly value={selectedStock?.stock?.price} />
                    </Form.Group>
                </div>
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <Button
                        onClick={() => {
                            if (createLoading) return;
                            _clearData();
                            setShowCreateOrderModal(false);
                        }}
                        style={{ background: 'transparent', color: COLOR_APP_CANCEL, borderColor: COLOR_APP_CANCEL }}>
                        ຍົກເລີກ
                    </Button>
                    <Button
                        onClick={() => {
                            if (createLoading) return;
                            _createOrder();
                        }}
                        style={{ background: COLOR_APP, marginLeft: 10, width: 100, border: 'none' }}>
                        {createLoading ? <Spinner
                            size="sm"
                            animation="border"
                        /> : "ບັນທືກ"}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default CreateOrderModal;